/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to set a placeholder text for the widget
 * <br><br>
 * <strong>Contract:</strong> <br>
 * This mixin expects that the widget also mixes in <em>TextInputValueMixin</em><br>
 *
 * @module mw-form/mixins/property/PlaceholderMixin
 *
 * @copyright Copyright 2014 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/dom",
    "dojo/dom-construct",
    "dojo/on",
    "dijit/focus",
    "mw-form/mixins/property/TextInputValueMixin"
], function (declare, lang, dom, domConstruct, on, focusUtil,
             TextInputValueMixin) {

    var PlaceholderMixin = declare(null, {

        /**
         * @property  {String} placeholder  - text content that appears as the placeholder in the widget
         * @instance
         * @default ""
         */
        placeholder: "",

        _setPlaceholderAttr: function (placeholder) {
            if (typeof placeholder !== "string") {
                throw new Error("'placeholder' property expects a literal string!");
            }

            this.inputNode.placeholder = placeholder;
            this._set("placeholder", placeholder);
        }

    });
    PlaceholderMixin._dependencies = [
        {mixin: TextInputValueMixin, orderDependent: false}
    ];
    return PlaceholderMixin;

});
